import { $, $$ } from 'utils/dom';
import Swiperslider from 'modules/swiper/swiper';

const downloads = $$('.downloads');

if (downloads.length) {
  downloads.forEach(download => {
    const slider = new Swiperslider($('.downloads__item-wrapper', download), {
      container: download,
      sliderOptions: {
        spaceBetween: 30,
        breakpoints: {
          768: {
            spaceBetween: 80,
          },
        },
      },
    });
    slider.init();
  });
}
